import {NgZone} from "@angular/core";

type RafTaskKey = object;
type RafTask = () => void;

export class RafCoordinator
{
    private m_tasks                    = new Map<RafTaskKey, RafTask>();
    private m_rafHandle: number | null = null;

    /** @param zone Pass NgZone to run the rAF request outside Angular's zone; null runs it inside. */
    public schedule(key: RafTaskKey,
                    task: RafTask,
                    zone: NgZone | null): void
    {
        this.m_tasks.set(key, task);

        if (this.m_rafHandle != null) return;

        const request = () =>
        {
            this.m_rafHandle = window.requestAnimationFrame(() => this.flush());
        };

        zone ? zone.runOutsideAngular(request) : request();
    }

    public cancel(key: RafTaskKey): void
    {
        this.m_tasks.delete(key);

        if (this.m_tasks.size !== 0 || this.m_rafHandle == null) return;

        window.cancelAnimationFrame(this.m_rafHandle);
        this.m_rafHandle = null;
    }

    private flush(): void
    {
        this.m_rafHandle = null;
        const tasks      = Array.from(this.m_tasks.values());
        this.m_tasks.clear();

        for (const task of tasks)
        {
            try
            {
                task();
            }
            catch (error)
            {
                console.error("Error while executing scheduled rAF task.", error);
            }
        }
    }
}
